import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import LimitList from '@/components/FamiliesList/LimitList.vue';
import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';

type Props = {
    itemsAmount: number;
    showFirstLastPage?: boolean;
    totalVisible?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FamiliesPagination',
  props: {
    itemsAmount: {},
    showFirstLastPage: { type: Boolean, default: true },
    totalVisible: { default: 6 }
  },
  setup(__props: any) {

const props = __props;
const store = useStore();

const page = ref<number>(1);
const limitList = [20, 50, 100] as const satisfies number[];

const currentLimit = ref<typeof limitList[number]>(limitList[0]);

const maxPages = computed<number>(() => Math.ceil(props.itemsAmount / currentLimit.value));

watch(page, (newPage) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    store.commit('families/setFilter', { offset: newPage });
});

watch(currentLimit, () => {
    page.value = 1; // Reset page when limit changes
    store.commit('families/setFilter', { limit: currentLimit.value });
});

const filter = computed(() => store.getters['families/getFilter']);
watch(filter, (newFilter) => {
    page.value = newFilter.offset ?? 1;
    currentLimit.value = newFilter.limit ?? limitList[0];
}, { immediate: true, deep: true });

const breakpoints = useVuetifyBreakpoints();

const isDesktop = breakpoints.greaterOrEqual('md');

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    justify: "space-between",
    class: "mb-5"
  }, {
    default: _withCtx(() => [
      _createVNode(LimitList, {
        modelValue: currentLimit.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLimit).value = $event)),
        "limit-list": limitList,
        class: "order-1 order-sm-0"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "6",
        class: "d-flex justify-center justify-sm-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_pagination, {
            modelValue: page.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
            length: maxPages.value,
            "show-first-last-page": props.showFirstLastPage,
            "total-visible": props.totalVisible,
            density: "compact",
            "active-color": "#ED1C24"
          }, _createSlots({ _: 2 }, [
            (_unref(isDesktop))
              ? {
                  name: "prev",
                  fn: _withCtx((prevProps) => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      class: _normalizeClass(["v-btn prev-next-button", {'v-btn--disabled': prevProps.disabled}]),
                      disabled: prevProps.disabled,
                      "aria-label": _ctx.$t('label.previous'),
                      "aria-disabled": prevProps.disabled
                    }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "v-btn__overlay" }, null, -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "v-btn__underlay" }, null, -1)),
                        _createElementVNode("span", {
                          class: "v-btn__content",
                          onClick: () => prevProps.disabled || page.value--
                        }, _toDisplayString(_ctx.$t('label.previous')), 9, _hoisted_1)
                      ]),
                      _: 2
                    }, 1032, ["class", "disabled", "aria-label", "aria-disabled"])
                  ]),
                  key: "0"
                }
              : undefined,
            (_unref(isDesktop))
              ? {
                  name: "next",
                  fn: _withCtx((nextProps) => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      class: _normalizeClass(["v-btn prev-next-button", {'v-btn--disabled': nextProps.disabled}]),
                      disabled: nextProps.disabled,
                      "aria-label": _ctx.$t('label.next'),
                      "aria-disabled": nextProps.disabled
                    }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "v-btn__overlay" }, null, -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "v-btn__underlay" }, null, -1)),
                        _createElementVNode("span", {
                          class: "v-btn__content",
                          onClick: () => nextProps.disabled || page.value++
                        }, _toDisplayString(_ctx.$t('label.next')), 9, _hoisted_2)
                      ]),
                      _: 2
                    }, 1032, ["class", "disabled", "aria-label", "aria-disabled"])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1032, ["modelValue", "length", "show-first-last-page", "total-visible"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})